import { ENV } from '@environment';
/* eslint-disable prettier/prettier */
import { MyThunkResult } from 'store';

import { hotelLocationsSuccessful, hotelLocationsError, hotelLocationsRequest } from 'action-creators/hotelLocations';
import {
  AutoCompleteDestinationStaticContent_Hotels_Response,
  AutoCompleteDestinationStaticContent_Location_Response,
  TravelHotelSearchResponse,
  TravelHotelSearch_HotelLocation_Response,
  TravelHotelSearch_Location_Response,
} from 'models/hotelLocation';
import { getCurrentLanguage } from 'utils/generic';
import { getLanguageWithoutRegion } from 'utils/i18n';

import { axiosConfig, rappiServicesTravelSearchHotels } from '../api';

export const searchHotelLocations =
  (text: string): MyThunkResult<Promise<void>> =>
  async (dispatch, getState) => {
    try {
      dispatch(hotelLocationsRequest());
      const { country } = getState().i18n;
      const currentLanguage = country ? getLanguageWithoutRegion(getCurrentLanguage()) : 'ES';
      const countryId = getState().user.accountResult?.countryId ?? '';
      const autoCompleteVersion =
        ENV.API.RAPPI_SERVICES_TRAVEL_HOTEL_SEARCH !== '' ? 'travel-hotel-search' : 'static-content';

      const { data } = await rappiServicesTravelSearchHotels.get<any>('', {
        params: {
          query: text.sanitize(),
          searchCriteria: text.sanitize(),
          lang: currentLanguage.toUpperCase(),
          country: countryId,
          limit: 10,
          userServices: 'netviajes',
        },
        ...axiosConfig,
      });

      const response = convertAutoCompleteResponse(data, autoCompleteVersion);

      dispatch(hotelLocationsSuccessful(response));
    } catch (ex) {
      dispatch(hotelLocationsError(ex));
    }
  };

const convertAutoCompleteResponse = (response: any, version: string): TravelHotelSearchResponse => {
  if (version === 'travel-hotel-search') {
    return response as TravelHotelSearchResponse;
  }

  const result: TravelHotelSearchResponse = {
    hotels: (response.Hotels as AutoCompleteDestinationStaticContent_Hotels_Response[]).map(
      (i) =>
        ({
          Id: i.Id,
          hotel_name: i.hotel_name,
          address: i.address,
        } as unknown as TravelHotelSearch_HotelLocation_Response),
    ) as TravelHotelSearch_HotelLocation_Response[],
    locations: (response.Locations as AutoCompleteDestinationStaticContent_Location_Response[]).map(
      (i) =>
        ({
          Id: i.Id,
          Type: i.Type,
          Name: i.Name,
          NameFull: i.NameFull,
          nearestIataCode: i.NearestIataCode,
        } as unknown as TravelHotelSearch_Location_Response),
    ) as TravelHotelSearch_Location_Response[],
  };

  return result;
};
